// import defaultIcon from "./../../assets/img/logo_icon.png";

import aws from "../../assets/img/icons/svg/aws.svg";
import gmail from "../../assets/img/icons/svg/gmail.svg";
import google from "../../assets/img/icons/svg/google.svg";
import python from "../../assets/img/icons/svg/python.svg";
import gcloud from "../../assets/img/icons/svg/gcloud.svg";
import azure from "../../assets/img/icons/svg/azure.svg";
import spark from "../../assets/img/icons/svg/spark.svg";
import jira from "../../assets/img/icons/svg/jira.svg";
import slack from "../../assets/img/icons/svg/slack.svg";
import googlesheets from "../../assets/img/icons/svg/googlesheets.svg";
import googlecalendar from "../../assets/img/icons/svg/googlecalendar.svg";
import youtube from "../../assets/img/icons/svg/youtube.svg";
import sonarqube from "../../assets/img/icons/svg/sonarqube.svg";
import awscloudwatch from "../../assets/img/icons/svg/awscloudwatch.svg";
import salesforce from "../../assets/img/Salesforce.png";
import {
    FaHome, FaCog, FaSearch, FaCopy, FaPaste, FaCut, FaUpload, FaDownload,
    FaTrash, FaEdit, FaPlus, FaMinus, FaSave, FaEye, FaEyeSlash, FaUser,
    FaUsers, FaLock, FaUnlock, FaBell, FaInfoCircle, FaQuestionCircle, FaServer, FaWikipediaW, FaFirefoxBrowser
} from "react-icons/fa";
import { FaGithub, FaSackDollar } from "react-icons/fa6";
import { GrDocumentTransfer } from "react-icons/gr";
import { BsFiletypeSql } from "react-icons/bs";


export const sxIcons = {
    // Local Images
    aws: <img src={aws} alt="AWS" width={30} height={30} />,
    awss3: <img src={aws} alt="AWS S3" width={30} height={30} />,
    google: <img src={google} alt="Google" width={30} height={30} />,
    gmail: <img src={gmail} alt="Gmail" width={30} height={30} />,
    python: <img src={python} alt="Python" width={30} height={30} />,
    gcloud: <img src={gcloud} alt="GCloud" width={25} height={25} />,
    azure: <img src={azure} alt="Azure" width={30} height={30} />,
    spark: <img src={spark} alt="Spark" width={30} height={30} />,
    jira: <img src={jira} alt="Jira" width={30} height={30} />,
    slack: <img src={slack} alt="Slack" width={30} height={30} />,
    googlesheets: <img src={googlesheets} alt="GoogleSheets" width={30} height={30} />,
    googlecalendar: <img src={googlecalendar} alt="GoogleCalendar" width={30} height={30} />,
    youtube: <img src={youtube} alt="YouTube" width={30} height={30} />,
    sonarqube: <img src={sonarqube} alt="Sonarqube" width={60} height={60} />,
    awscloudwatch: <img src={awscloudwatch} alt="AWSCloudwatch" width={30} height={30} />,
    salesforce: <img src={salesforce} alt="Salesforce" width={30} height={30} />,
    //React Component Icons
    home: <FaHome />,
    settings: <FaCog />,
    search: <FaSearch />,
    extract: <GrDocumentTransfer />,
    copy: <FaCopy />,
    paste: <FaPaste />,
    cut: <FaCut />,
    upload: <FaUpload />,
    download: <FaDownload />,
    delete: <FaTrash />,
    edit: <FaEdit />,
    add: <FaPlus />,
    remove: <FaMinus />,
    save: <FaSave />,
    sql: <BsFiletypeSql />,
    wikipedia: <FaWikipediaW />,
    sftp: <FaServer />,
    browser: <FaFirefoxBrowser />,
    financial: <FaSackDollar />,
    github: <FaGithub color="#000000"/>,

    view: <FaEye />,
    hide: <FaEyeSlash />,

    user: <FaUser />,
    users: <FaUsers />,

    lock: <FaLock />,
    unlock: <FaUnlock />,

    notification: <FaBell />,
    info: <FaInfoCircle />,
    help: <FaQuestionCircle />
    // font awesome icons
    // copy: <i className="fa-solid fa-copy" />
};